"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/*

The actual code for the my page component is found in rubics-service

*/
var MyPage = {
    name: "global:myPage",
    label: "Min Side",
    description: "På min side kan en innlogget bruker se og endre informasjon om seg selv",
    reactComponent: function () { return null; },
    icon: "myPage",
    usableInSection: true,
    props: [
        {
            name: "homeText",
            label: "Forsidetekst",
            type: "draft",
        },
    ],
};
exports.default = MyPage;
//# sourceMappingURL=index.js.map